import { render, staticRenderFns } from "./PollPoolsGrid.vue?vue&type=template&id=157496a5"
import script from "./PollPoolsGrid.vue?vue&type=script&lang=js"
export * from "./PollPoolsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports